import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface CopyPayrollRequest {
  id?: string
  originPayrollId: string
  destinationPayrollId: string
  concepts: string[]
  configFields?: string[]
  isUpgradable: boolean
}

export async function getCopyPayrollRequests(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = [`companies.country_id = :countryId`]
  if (search) {
    where.push(
      `CONCAT(payroll_copy_requests.updated_at,process_status.code,CONCAT(origin_payroll.code,' - ',origin_payroll.name),CONCAT(destination_payroll.code,' - ',destination_payroll.name),jsonb_array_length(payroll_copy_requests.concepts), payroll_copy_requests.errors) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by payroll_copy_requests.updated_at desc'])
  // result
  let data: any = await getData({
    tables: ['pg_payroll_copy_requests'],
    fields: [
      'payroll_copy_requests.id',
      'payroll_copy_requests.user',
      'payroll_copy_requests.errors',
      'payroll_copy_requests.is_upgradable',
      'payroll_copy_requests.updated_at',
      'process_status.code as status_code',
      "CONCAT(origin_payroll.code,' - ',origin_payroll.name) as payroll_origin",
      "CONCAT(destination_payroll.code,' - ',destination_payroll.name) as payroll_destination",
      'jsonb_array_length(payroll_copy_requests.concepts) AS concepts',
      "CONCAT(COALESCE(jsonb_array_length(payroll_copy_requests.new_concepts),0),'/',COALESCE(jsonb_array_length(payroll_copy_requests.concepts),0)) AS concept_summary",
      "CONCAT(COALESCE(jsonb_array_length(payroll_copy_requests.new_bases),0),'/',COALESCE(jsonb_array_length(payroll_copy_requests.bases),0)) AS base_summary"
    ],
    join: [
      'LEFT JOIN process_status ON process_status.id = payroll_copy_requests.process_status_id',
      'LEFT JOIN payrolls AS origin_payroll ON origin_payroll.id = payroll_copy_requests.origin_payroll_id',
      'LEFT JOIN payrolls AS destination_payroll ON destination_payroll.id = payroll_copy_requests.destination_payroll_id',
      'LEFT JOIN companies ON companies.id = destination_payroll.company_id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })

  return data[0]
}

export async function getPayroll(
  userId: string,
  country?: string,
  discardedPayroll?: string
) {
  const payrolls = await getData<any>({
    tables: ['pg_user_enabled_payrolls'],
    join: [
      'INNER JOIN payrolls ON user_enabled_payrolls.payroll_id = payrolls.id'
    ],
    fields: ['payrolls.code'],
    where: [`user_enabled_payrolls.user_id = '${userId}'`]
  })
  // where's
  const where = [
    `payrolls.code IN (${payrolls[0].results
      .map((payroll: any) => `'${payroll.code}'`)
      .join(', ')})`,
    'payrolls.is_inactive = false'
  ]
  if (country) {
    where.push(`countries.id = '${country}'`)
  }
  if (discardedPayroll) {
    where.push(`payrolls.id <> '${discardedPayroll}'`)
  }
  const data = await getData<any>({
    tables: ['pg_payrolls'],
    fields: [
      'payrolls.id',
      "CONCAT(payrolls.code,'-',payrolls.name) as name",
      'payrolls.name as payroll',
      'payrolls.code',
      'currencies.name as currency',
      'countries.id as countryId',
      'frequencies.name as frequency',
      'companies.name as company'
    ],
    join: [
      'INNER JOIN currencies ON payrolls.currency_id = currencies.id',
      'INNER JOIN companies ON payrolls.company_id = companies.id',
      'INNER JOIN countries ON companies.country_id = countries.id',
      'INNER JOIN frequencies ON frequencies.id = payrolls.frequency_id'
    ],
    where
  })

  return data[0].results
}

export async function getConcepts(payrollId: string) {
  const data = await getData<any>({
    tables: ['pg_concepts'],
    fields: [
      'concepts.id',
      'concepts.name',
      'concepts.code',
      'INITCAP(concept_formats.name) as format',
      "CASE WHEN master_concepts.is_standard = true THEN 'Si' ELSE 'No' END AS is_standard"
    ],
    join: [
      'INNER JOIN master_concepts ON master_concepts.id = concepts.master_concept_id',
      'INNER JOIN concept_formats ON concept_formats.id = concepts.concept_format_id'
    ],
    where: [
      'concepts.is_inactive = false',
      'concepts.is_deleted = false',
      `concepts.payroll_id = '${payrollId}'`
    ]
  })

  return data[0].results
}

export async function createCopyPayrollRequest(
  data: CopyPayrollRequest
): Promise<boolean> {
  const response: any = await http.post('payroll/copy-request', {
    originPayrollId: data.originPayrollId,
    destinationPayrollId: data.destinationPayrollId,
    concepts: data.concepts,
    configFields: data.configFields,
    isUpgradable: data.isUpgradable
  })

  if (response?.data?.data?.error) {
    return false
  }

  return true
}
